var render = function render(){var _vm=this,_c=_vm._self._c;return _c('z-table',{ref:"table",attrs:{"columns":_vm.columns,"uploadAble":true,"route":`hkoption/${_vm.bookName}/stock`,"rowKey":"id"},on:{"beforeUpload":_vm.beforeUpload}})
}
var staticRenderFns = []

export { render, staticRenderFns }